import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "bgrid" }
const _hoisted_2 = { class: "button-wrapper" }
const _hoisted_3 = {
  key: 0,
  class: "ms-2 filter-description"
}

import BTable from "../BTable/BTable.vue";
import BTableHeader from "../BTable/BTableHeader.vue";
import BFilterModal from "../BFilterEditor/BFilterModal.vue";
import LoadingSpinner from "../Misc/LoadingSpinner.vue";
import {computed, ref} from "vue";
import {BTableColumn, BTableOptions} from "../BTable/BTable.types";
import {BFilterableField, BFilterOptions, describeFilters, validateFilters} from "../BFilterEditor/BFilterEditor.types";

import {useSlots} from "vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'BGrid',
  props: {
    caption: {},
    columns: {},
    tableOptions: {},
    filterOptions: {},
    filterableFields: {},
    items: {},
    loading: { type: Boolean, default: false },
    showFilter: { type: Boolean, default: true },
    showPaging: { type: Boolean, default: true },
    currentItemCount: { default: -1 }
  },
  emits: ["optionChange"],
  setup(__props: any, { emit: __emit }) {

const slots = useSlots();

const props = __props;

const isShowFilterEditor = ref(false);
const hasAppliedFilters = ref(props.filterOptions != null && props.filterOptions.filters.length);

const canShowFilter = computed(() => {
    return props.showFilter && props.filterableFields && props.filterableFields.length > 0;
});

const numberOfReturnedItems = computed(() => {
    return props.items?.length;
});

const itemsToDisplay = computed(()=> {
    if(props.showPaging && props.tableOptions?.pagingMode == "noTotal"){
        //When were hiding the total text,first button, and last button then we return itemsPerPage + 1 in our get data call.
        //If the returned amount of rows is greater than itemsPerPage then enable the next button otherwise disable the next button to prevent an error
        return props.items?.slice(0, props.tableOptions.itemsPerPage);
    } 
    
    return props.items;
});
const emit = __emit;

const showFilterEditor = function () {
    isShowFilterEditor.value = true;
};
const handleDismiss = function () {
    isShowFilterEditor.value = false;
};
const handleOptionChange = async function (options: BTableOptions) {
    await getData();
};

const getData = async () => {
    emit("optionChange");
};

const filtersDescription = computed(() => {
    if (props.filterOptions == null) {
        return "";
    }
    return describeFilters(props.filterOptions.filters, props.filterableFields!);
});

const resetFilters = async () => {
    if (props.filterOptions != null) {
        props.filterOptions.filters = [];
        props.tableOptions!.page = 1;
        await getData();
    }
    isShowFilterEditor.value = false;
    hasAppliedFilters.value = false;
};

const applyFilters = async (newFilterOptions: BFilterOptions) => {  
    if(!validateFilters(newFilterOptions.filters)){
        return;
    }    

    if (props.filterOptions) {
        props.filterOptions.filters = newFilterOptions.filters;
        props.tableOptions!.page = 1;
    }

    isShowFilterEditor.value = false;
    await getData();
};

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (canShowFilter.value)
      ? (_openBlock(), _createBlock(BFilterModal, {
          key: 0,
          modelValue: isShowFilterEditor.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isShowFilterEditor).value = $event)),
          filterOptions: _ctx.filterOptions!,
          filterableFields: _ctx.filterableFields!,
          onFilterChanged: applyFilters,
          onDismissModal: handleDismiss
        }, null, 8, ["modelValue", "filterOptions", "filterableFields"]))
      : _createCommentVNode("", true),
    _createVNode(BTableHeader, {
      value: props.showPaging ? _ctx.tableOptions : null,
      onOptionChange: handleOptionChange,
      "header-slot-class": "b-header-slot w-100 position-relative",
      "current-item-count": props.currentItemCount
    }, {
      pagingStart: _withCtx(() => [
        _renderSlot(_ctx.$slots, "pagingStart")
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "beforeFilter"),
          (canShowFilter.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _withModifiers(showFilterEditor, ["prevent"]),
                class: "btn btn-primary filter-button-width"
              }, _cache[2] || (_cache[2] = [
                _createElementVNode("i", {
                  class: "bi bi-search me-1",
                  "aria-hidden": "true"
                }, null, -1),
                _createTextVNode(" Filter ")
              ])))
            : _createCommentVNode("", true)
        ]),
        _renderSlot(_ctx.$slots, "header.toolbar"),
        (filtersDescription.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("span", null, _toDisplayString(filtersDescription.value), 1),
              _withDirectives(_createElementVNode("button", {
                class: "btn-close",
                "aria-label": "Remove all currently applied filters.",
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (resetFilters()), ["prevent"]))
              }, null, 512), [
                [_directive_tooltip, `Remove all currently applied filters.`]
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 3
    }, 8, ["value", "current-item-count"]),
    _createVNode(BTable, {
      items: itemsToDisplay.value,
      columns: _ctx.columns,
      caption: _ctx.caption!,
      value: _ctx.tableOptions!,
      onOptionChange: handleOptionChange
    }, _createSlots({ _: 2 }, [
      _renderList(_ctx.columns, (column) => {
        return {
          name: `header.${column.key}`,
          fn: _withCtx(() => [
            _renderSlot(_ctx.$slots, `header.${column.key}`, { column: column })
          ])
        }
      }),
      _renderList(_ctx.columns, (column) => {
        return {
          name: `header.bottom.${column.key}`,
          fn: _withCtx(() => [
            _renderSlot(_ctx.$slots, `header.bottom.${column.key}`, { column: column })
          ])
        }
      }),
      _renderList(_ctx.columns, (column) => {
        return {
          name: `cell.${column.key}`,
          fn: _withCtx(({item}) => [
            _renderSlot(_ctx.$slots, `cell.${column.key}`, {
              column: column,
              item: item
            })
          ])
        }
      })
    ]), 1032, ["items", "columns", "caption", "value"]),
    (_ctx.showPaging)
      ? (_openBlock(), _createBlock(BTableHeader, {
          key: 1,
          value: _ctx.tableOptions!,
          onOptionChange: handleOptionChange,
          "header-slot-class": "b-header-slot w-100",
          "current-item-count": props.currentItemCount
        }, null, 8, ["value", "current-item-count"]))
      : _createCommentVNode("", true),
    _createVNode(LoadingSpinner, { "show-loading": _ctx.loading }, null, 8, ["show-loading"])
  ]))
}
}

})